import { labelids } from "../../assets/data/TkExplanationProperty";
import { ITkFakeTableLineProps } from "../../type/componentsType/TkFakeTableLine";

const fakeTableList: ITkFakeTableLineProps[] = [
  {
    keyword: "info",
    type: "explanatoryText",
    explanatoryText: labelids.labelid.LBLC060130_01,
    explanatoryTextRule: "\\n",
  },
  {
    keyword: "contractorName",
    type: "contractorAndNumber",
    contractorName: "契約者（法人）名",
    showLine: false,
  },
  {
    title: "引継ぎコード",
    keyword: "transferCd",
    type: "text",
  },
  {
    title: "職員氏名",
    keyword: "staffNameKanji",
    type: "text",
  },
  {
    title: "退職月の出勤日数",
    keyword: "workingDayNum",
    type: "text",
  },
];

const schema = {};

export { fakeTableList, schema };
